import { FieldApi, ValidationError } from "@tanstack/react-form";

import { ZodType } from "zod";
import { RelationModel } from "../../../../relation/domain/models/RelationModel";
import Select from "react-select";
import { useMemo } from "react";
import { Button } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

export const DefaultRouteFormRelationEntitySelect = ({
  subField,
  values,
  relations,
  removeField,
}: {
  subField: FieldApi<
    {
      [x: string]: unknown | number;
    },
    `relations[${number}]`,
    undefined,
    () => {
      validate({ value }: { value: unknown }, fn: ZodType): ValidationError;
      validateAsync(
        { value }: { value: unknown },
        fn: ZodType,
      ): Promise<ValidationError>;
    }
  >;
  values: (number | undefined)[] | undefined;
  relations: RelationModel[];
  removeField: () => void;
}) => {
  const options = useMemo(() => {
    return relations
      .map((relation) => ({
        value: relation.id,
        label: relation.name,
      }))
      .filter(
        (option) =>
          subField.state.value == option.value ||
          !values?.includes(option.value),
      );
  }, [relations, values]);
  const { t } = useTranslation("common");

  return (
    <div className="d-flex flex-row align-items-center gap-2">
      <Select
        noOptionsMessage={() => {
          return t("No options");
        }}
        className="w-100 entity-select"
        options={options}
        value={options.find((option) => option.value === subField.state.value)}
        onChange={(option) => {
          if (option === null) return;
          if (
            option.value === undefined ||
            option.value === subField.state.value
          )
            return;
          subField.handleChange(option.value);
        }}
        classNamePrefix={"entity-select"}
      ></Select>
      <Button variant="danger" onClick={removeField} className="btn-sm">
        <Trash />
      </Button>
    </div>
  );
};
